export default {
  props: {
    // 高级查询动态表单URL
    criteriaFormUrl: {
      type: String,
      default: null,
    },
    // 扩展对象属性会出现在，绑定模板变量的 extend 中
    extendData: {
      type: Object,
      default: null,
    },
    // 菜单按钮获取URL
    buttonMenuListUrl: {
      type: String,
      default: null,
    },
    indexLabel: {
      type: String,
      default: '序号',
    },
    //主从模式列表高级查询code
    criteriaCode: {
      type: String,
      default: '',
    },
    detailModel: {
      type: [String, Number],
      default: '',
    },
    // 列表定义配置获取URL(配置此参数后tableColDefaultUrl和tableColCode失效)
    tableColumnDefUrl: {
      type: String,
      default: null,
    },
    tableColCode: {
      type: String,
      default: '',
    },
    tableColDefaultUrl: {
      type: String,
      default: 'rest/main/dict/getTableByCode?tableCode=',
    },
    ifCacheQuery: {
      type: Boolean,
      default: true,
    },
    cacheQueryKey: {
      type: String,
      default: null,
    },
    // 查询请求方式
    urlQueryMethod: {
      type: String,
      default: 'post',
    },

    confirmCondition: {
      // 是否需要先决条件
      type: Array,
      default: [],
    },
    sureBtn: {
      //先决条件按钮的文本
      type: String,
      default: '确定',
    },
    confirmConditionFormItemDefUrl: {
      // 先决条件配置的form - tableTopFormItemDefUrl
      type: String,
      default: '',
    },
    specialState: {
      //自定义的store初始状态
      type: Object,
      default: () => ({}),
    },
    specialMutations: {
      //自定义的store初始Mutations
      type: Object,
      default: () => ({}),
    },
    specialActions: {
      // 自定义的store初始Actions
      type: Object,
      default: () => ({}),
    },
    getOrderDataUrl: {
      // 查询主单（order）数据的 接口
      type: String,
      require: true,
      default: null,
    },
    getOrderDataParams: {
      // 查询主单（order）数据的 参数
      type: Object,
      default: null,
    },
    saveconfirmConditionDataUrl: {
      // 保存先决条件数据的 接口
      type: String,
      default: null,
    },
    saveconfirmConditionDataParams: {
      // 保存先决条件数据的 参数
      type: Object,
      default: null,
    },
    urlQuery: {
      // 查询商品明细数据的 接口
      type: String,
      require: true,
      default: null,
    },
    urlQueryParamter: {
      // 查询商品明细数据的 参数
      type: Object,
      default: null,
    },
    saveSingleItemUrl: {
      // 保存单行明细数据的 接口
      type: String,
      require: true,
      default: null,
    },
    saveSingleItemParams: {
      // 保存单行明细数据的 参数
      type: Object,
      default: null,
    },
    toCarPath: {
      // 点击购物车跳转 的路径
      type: String,
      require: true,
      default: null,
    },
    saveDraft: {
      // 保存单据草稿状态的URL
      type: String,
      require: true,
      default: null,
    },
    isInWarehouse:{
      type: Boolean,
      default: false
    }
  },
}
